import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import {
  _add_task_comment,
  _delete_task,
  _delete_task_comment,
  _project_detail,
  _task_comment_list,
  _update_task_comment,
  _update_task_end_date,
  _update_task_members,
  _update_task_priority,
  _update_task_status,
  _update_task_tags_in_task,
} from "src/DAL";

import { useAppContext } from "src/hooks";
import TaskDetailDialog from "src/components/TaskDetailDrawer/TaskDetailDialog";
import DaashboardTaskCard from "src/pages/dashboard/components/DaashboardTaskCard";
import { MuiDialog } from "src/components";
import { useNavigate } from "react-router-dom";

/* <<--------------------------------------------------------->> */

function OpenTaskDetail({
  task,
  getCalendarTasks = () => {},
  open = false,
  setOpen = () => {},
  closeNotification = () => {}, // for closing notification after navigate
}) {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedTask, setSelectedTask] = useState(undefined);
  const [taskDetailOpen, setTaskDetailOpen] = useState(false);
  const [projectTeam, setProjectTeam] = useState([]);
  const [projectTags, setProjectTags] = useState([]);
  const [editCommentTitle, setEditCommentTitle] = useState("");
  const [selectedComment, setSelectedComment] = useState();
  const [editingCommentId, setEditingCommentId] = useState("");
  const [taskDetailLoading, setTaskDetailLoading] = useState(true);
  const [loadingComments, setLoadingComments] = useState(false);
  const [processing, setProcessing] = useState(false);
  const { dispatch_get_user_profile, socketEmit } = useAppContext();
  const [newComment, setNewComment] = useState("");
  const [delTaskOpen, setDelTaskOpen] = useState(false);
  const [delCommentOpen, setDelCommentOpen] = useState(false);
  const [deletingTaskComment, setDeletingTaskComment] = useState(false);

  const currentTask = () => {
    if (selectedTask) {
      return selectedTask;
    }
    return undefined;
  };

  const openDelTask = () => {
    setDelTaskOpen(true);
  };
  const closeDelTask = () => {
    setDelTaskOpen(false);
  };

  const handleDeleteTask = async () => {
    let selectedTask = currentTask();
    console.log(selectedTask, "-on-del-task");
    const data = {
      task_id: selectedTask?._id,
      task_type: selectedTask?.task_type,
      task_order: selectedTask?.order,
    };
    console.log(data, "del-task-req");
    setProcessing(true);
    const result = await _delete_task(selectedTask?._id);
    if (result.code === 200) {
      if (getCalendarTasks) {
        getCalendarTasks();
      }
      closeTaskDetail();
      closeDelTask();
      console.log(result, "res");
      setProcessing(false);
      enqueueSnackbar("Task deleted successfully", { variant: "success" });
    } else {
      setProcessing(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const closeTaskDetail = () => {
    setTaskDetailOpen(false);
    setEditingCommentId("");
    setNewComment("");
    setSelectedTask(undefined);
    if (open) {
      setOpen(false);
    }
  };

  const onDelComment = (_comment) => {
    setSelectedComment(_comment);
    openDelCommentDialog();
  };
  const openDelCommentDialog = () => {
    setDelCommentOpen(true);
  };
  const closeDelCommentDialog = () => {
    setDelCommentOpen(false);
  };
  const handleDelTaskComment = async () => {
    console.log(selectedComment, "to-del");
    if (!selectedComment) {
      console.log("no selectedComment");
      return;
    }
    setDeletingTaskComment(true);

    const result = await _delete_task_comment(
      { comment_id: selectedComment._id },
      selectedTask?._id
    );
    if (result.code === 200) {
      console.log(result, "del-com-res");
      setDeletingTaskComment(false);
      closeDelCommentDialog();
      enqueueSnackbar("Comment deleted successfully", { variant: "success" });
      const updated_comments = (_comments) => {
        return _comments.filter(
          (item) => String(item._id) !== String(selectedComment._id)
        );
      };
      setSelectedTask((prev) => {
        return { ...prev, task_comment: updated_comments(prev.task_comment) };
      });
      // setSelectedTaskComments((prev) => updated_comments(prev));
      const updated_tasks = (_tasks) => {
        let updated = _tasks.map((item) => {
          if (String(item._id) === String(selectedTask?._id)) {
            return {
              ...item,
              task_comment_count:
                item.task_comment_count > 0
                  ? Number(item.task_comment_count) - 1
                  : 0,
              task_comment: updated_comments(item.task_comment),
            };
          }
          return item;
        });
        return updated;
      };
      let temp = allFilteredTasksBySections[selectedTask?.section_id];
      setAllFilteredTasksBySections((prev) => {
        return {
          ...prev,
          [selectedTask?.section_id]: {
            ...temp,
            task_list: updated_tasks(temp.task_list),
          },
        };
      });
      setSelectedComment(undefined);
      closeDelCommentDialog();
    } else {
      setDeletingTaskComment(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  /* <<--------------------------------------------------------->> */

  const getTaskComments = async (task, noLoader) => {
    if (!noLoader) {
      setLoadingComments(true);
    }

    const result = await _task_comment_list(task._id);
    console.log(result, "com-list");
    setLoadingComments(false);
  };

  const afterCommentAction = () => {
    getTaskComments(selectedTask, true);
    setSelectedComment();
    setEditCommentTitle("");
    setEditingCommentId("");
  };
  const handleAddComment = async (
    is_selected,
    type,
    opt,
    commentText = null,
    parent_comment_id = null
  ) => {
    if (!selectedTask) {
      return { code: 400, message: "Retry" };
    }
    const textToSend = commentText !== null ? commentText : newComment;
    if (textToSend === "") {
      enqueueSnackbar("Comment cannot be empty", { variant: "warning" });
      return;
    }
    const data = {
      comment_title: textToSend.trim().replace(/<a /g, "<a target='_blank' "),
      comment_type: type,
    };
    if (parent_comment_id) {
      data.parent_comment_id = parent_comment_id;
    }

    console.log(data, "req-add-comm");
    const result = await _add_task_comment(data, selectedTask._id);
    afterCommentAction();
    if (result.code == 200) {
      setSelectedTask((prev) => {
        let found = prev.task_comment.findIndex(
          (item) => item._id == result.task_comment._id
        );
        if (found !== -1) {
          let temp = prev.task_comment;
          temp.splice(found, 1);
          temp.push(result.task_comment);
          return {
            ...prev,
            task_comment: [...temp],
          };
        } else {
          return {
            ...prev,
            task_comment: [...prev.task_comment, result.task_comment],
          };
        }
        // return { ...prev };
      });
      if (type == "0") {
        const { project, section_id, _id, workspace } = selectedTask;
        socketEmit("send_notification_to_all", {
          receiver: result.task_comment.allow_members,
          // data: result.Project,
          data: {
            task_id: _id,
            project_id: project.id,
            workspace_id: workspace.id,
          },
          message: `${dispatch_get_user_profile().first_name} ${
            dispatch_get_user_profile().last_name
          } added a comment in task`,
          link: `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`,
        });
      }
    }
    enqueueSnackbar(result.message, {
      variant: result.code == 200 ? "success" : "error",
    });
    return result;
  };

  const handleEditComment = async (e, type, commentText, comment) => {
    // const handleEditComment = async (selectedComment) => {
    //   const data = {
    //     comment_id: selectedComment._id,
    //     comment_title: selectedComment.comment_title,
    //     comment_type: selectedComment.comment_type,
    //   };
    if (!selectedTask) {
      return { code: 400, message: "Retry" };
    }
    const textToUpdate = commentText !== null ? commentText : editCommentTitle;
    const data = {
      comment_id: comment._id,
      comment_title: textToUpdate,
      comment_type: comment.comment_type,
    };
    console.log(data, "req-update-com");
    const result = await _update_task_comment(data, selectedTask._id);
    afterCommentAction();
    if (result.code == 200) {
      setSelectedTask((prev) => {
        return {
          ...prev,
          task_comment: prev.task_comment.map((oldComment) => {
            if (oldComment._id === result.task_comment._id) {
              return {
                ...result.task_comment,
                parent_comment_id: oldComment.parent_comment_id || result.task_comment.parent_comment_id,
              };
            } else {
              return { ...oldComment };
            }
          }),
        };
      });
    }
    return result;
  };

  const handleOpenTaskDetail = (_task) => {
    setSelectedTask(_task);
    setTaskDetailOpen(true);
  };
  const handleCloseTaskDetail = () => {
    setSelectedTask(undefined);
    setTaskDetailOpen(false);
    if (open) {
      setOpen(false);
    }
  };
  const handleCopyTaskLink = async (task) => {
    const { project, section_id, _id } = task;
    console.log(task, "to-copy");

    let newLink = "";
    newLink = `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`;
    console.log(newLink);
    // unsecuredCopyToClipboard(newLink);
    let has_error = "";
    try {
      await window.navigator.clipboard.writeText(newLink);
    } catch (error) {
      if (error) {
        if (error.message) {
          has_error = error.message;
        }
      }
      enqueueSnackbar("Something went wrong!", { variant: "error" });
    }
    if (has_error === "") {
      enqueueSnackbar("Task link copied to clipboard", { variant: "success" });
      return;
    }
    enqueueSnackbar("Could not copy task link", { variant: "error" });
  };

  const handleAction = (action, data) => {
    console.log(action, "action");
    console.log(data, "payload");
    if (action === "change_status") {
      handleChangeStatus(data);
    }
    if (action === "change_date") {
      handleChangeDate(data);
    }
    if (action === "change_priority") {
      handleChangePriority(data);
    }
    if (action === "change_members") {
      handleChangeMembers(data);
    }
    if (action === "del_task") {
      handleDelTask(data);
    }
    if (action === "copy_task_link") {
      handleCopyTaskLink(data);
    }
    if (action === "open_task_detail") {
      handleOpenTaskDetail(data);
    }
  };

  const handleChangeStatus = async (data) => {
    console.log(data, "change-status");
    const { is_checkbox, status, checked, task } = data;

    const updateTaskStatus = async (req_data, section_id) => {
      const result = await _update_task_status(req_data, section_id);
      if (result.code === 200) {
        taskDetailOpen && setSelectedTask(result.task_detail);
        enqueueSnackbar("Task status updated successfully", {
          variant: "success",
        });

        const { project, section_id, _id, workspace } = result.task_detail;
        socketEmit("send_notification_to_all", {
          receiver: result.task_detail.allow_members,
          // data: result.Project,
          data: {
            task_id: _id,
            project_id: project.id,
            workspace_id: workspace.id,
          },
          message: `${dispatch_get_user_profile().first_name} ${
            dispatch_get_user_profile().last_name
          } updated the task status`,
          link: `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`,
        });
        socketEmit("send_notification_to_all", {
          receiver: result.task_detail.hidden_members,
          // data: result.Project,
          data: {
            task_id: _id,
            project_id: project.id,
            workspace_id: workspace.id,
          },
          message: `A member updated the task status`,
          link: `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`,
        });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    };
    if (is_checkbox === false) {
      const req_data = {
        task_id: task._id,
        task_status: status,
        workspace_id: task.workspace_id,
        list_type: "0",
      };
      updateTaskStatus(req_data, task.section_id);
    }

    if (is_checkbox === true) {
      let updated_status = checked === true ? 3 : 0;
      const req_data = {
        task_id: task._id,
        task_status: updated_status,
        workspace_id: task.workspace_id,
        list_type: "0",
      };
      updateTaskStatus(req_data, task.section_id);
    }
  };

  const handleChangePriority = async (data) => {
    console.log(data, "change-priority");
    const { priority, task } = data;

    const req_data = {
      task_id: task._id,
      task_priority: priority,
      workspace_id: task.workspace_id,
      list_type: "0",
    };
    const result = await _update_task_priority(req_data, task.section_id);

    if (result.code === 200) {
      taskDetailOpen && setSelectedTask(result.task_detail);
      console.log(result, "res");
      enqueueSnackbar("Task priority updated successfully", {
        variant: "success",
      });
      let receiver = [result.task_detail.creator_profile.user_id];
      result.task_detail.team.map((member) => {
        receiver.push(member.user_id);
      });
      receiver = receiver.filter(
        (id) => id !== dispatch_get_user_profile().user_id
      );
      const { project, section_id, _id, workspace } = result.task_detail;
      socketEmit("send_notification_to_all", {
        receiver: result.task_detail.allow_members,
        // data: result.Project,
        data: {
          task_id: _id,
          project_id: project.id,
          workspace_id: workspace.id,
        },
        message: `${dispatch_get_user_profile().first_name} ${
          dispatch_get_user_profile().last_name
        } updated the task priority`,
        link: `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`,
      });
      socketEmit("send_notification_to_all", {
        receiver: result.task_detail.hidden_members,
        // data: result.Project,
        data: {
          task_id: _id,
          project_id: project.id,
          workspace_id: workspace.id,
        },
        message: `A member updated the task priority`,
        link: `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`,
      });
    } else {
      enqueueSnackbar(result.message, {
        variant: "error",
      });
    }
  };
  const onEditComment = (_comment) => {
    setSelectedComment(_comment);
    setEditCommentTitle(_comment.comment_title);
  };
  const handleChangeDate = async (data) => {
    console.log(data, "change-date");
    const { endDate, task } = data;
    const req_data = {
      task_id: task._id,
      end_date: endDate,
      workspace_id: task.workspace_id,
      list_type: "0",
    };
    const result = await _update_task_end_date(req_data, task.section_id);
    if (result.code === 200) {
      taskDetailOpen && setSelectedTask(result.task_detail);
      console.log(result, "res");
      let receiver = [result.task_detail.creator_profile.user_id];
      result.task_detail.team.map((member) => {
        receiver.push(member.user_id);
      });
      receiver = receiver.filter(
        (id) => id !== dispatch_get_user_profile().user_id
      );
      const { project, section_id, _id, workspace } = result.task_detail;
      socketEmit("send_notification_to_all", {
        receiver,
        // data: result.Project,
        data: {
          task_id: _id,
          project_id: project.id,
          workspace_id: workspace.id,
        },
        message: `${dispatch_get_user_profile().first_name} ${
          dispatch_get_user_profile().last_name
        } updated the target date of the task`,
        link: `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`,
      });
      // enqueueSnackbar("Target Date Updated Successfully", {
      //   variant: "success",
      // });
    } else {
      enqueueSnackbar(result.message, {
        variant: "error",
      });
    }
  };
  const handleDelTask = async (task) => {
    setSelectedTask(task);
    openDelTaskDialog();
  };

  const handleChangeMembers = async (data) => {
    console.log(data, "change-team");
    const { task, taskTeam, isSelected, targetUser, action } = data;

    let updated_team = Array.from(taskTeam);
    if (action === "add") {
      if (isSelected) {
        return;
      }
      if (!isSelected) {
        updated_team.push(targetUser);
      }
    }
    if (action === "remove") {
      if (isSelected) {
        updated_team = updated_team.filter(
          (user) => String(user.user_id) !== String(targetUser.user_id)
        );
      }
    }
    console.log(updated_team, "new-team");
    let updated_task_team = [];
    updated_team.map((user) => {
      updated_task_team.push(user);
    });
    const req_data = {
      task_id: task._id,
      team: updated_task_team,
      workspace_id: task.workspace_id,
      list_type: "0",
    };

    const result = await _update_task_members(req_data);
    if (result.code === 200) {
      taskDetailOpen && setSelectedTask(result.task_detail);
      if (action == "add") {
        let receiver = [targetUser.user_id];
        receiver = receiver.filter(
          (id) => id !== dispatch_get_user_profile().user_id
        );
        const { project, section_id, _id, workspace } = result.task_detail;
        socketEmit("send_notification_to_all", {
          receiver,
          // data: result.Project,
          data: {
            task_id: _id,
            project_id: project.id,
            workspace_id: workspace.id,
          },
          message: `${dispatch_get_user_profile().first_name} ${
            dispatch_get_user_profile().last_name
          } assigned you a task`,
          link: `${window.location.origin}/workspaces/copied-task-link/${project.id}/${section_id}/${_id}`,
        });
      }
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const onChangeTags = async (data) => {
    try {
      const result = await _update_task_tags_in_task(data);
      if (result.code == 200) {
        setSelectedTask(result.task_data);
      }
    } catch (error) {
      console.log(error, " catched while updating task tags");
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };

  const handleNavigate = (task) => {
    const { section_id, _id } = task;
    const project_id = task?.project.id;
    navigate(
      `/workspaces/copied-task-link/${project_id}/${section_id}/${_id}`,
      { state: { task_id: _id } }
    );
    handleCloseTaskDetail();
    closeNotification();
  };
  /* <<----- get project team ---------------------------------->> */
  const getProjectDetail = async () => {
    const result = await _project_detail(null, task.project.id);
    if (result.code === 200) {
      setProjectTeam(result.project_detail?.team || []);
      setProjectTags(result.project_detail?.tag_colors || []);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  /* <<--------------------------------------------------------->> */
  useEffect(() => {
    if (open) {
      getProjectDetail();
      handleAction("open_task_detail", task);
    }
  }, [open]);

  /* <<--------------------------------------------------------->> */

  return (
    <div>
      {currentTask() && (
        <TaskDetailDialog
          open={taskDetailOpen}
          onClose={handleCloseTaskDetail}
          task={selectedTask}
          setTask={setSelectedTask}
          projectTeam={projectTeam}
          projectTags={projectTags}
          setProjectTags={setProjectTags}
          onChangeTags={onChangeTags}
          onChangePriority={handleChangePriority}
          onChangeStatus={handleChangeStatus}
          onChangeMembers={handleChangeMembers}
          handleSendComment={handleAddComment}
          // handleSendComment={() =>
          //   handleAddComment({ title: newComment, type: 0 })
          // }
          handleUpdateTaskComment={handleEditComment}
          // handleUpdateTaskComment={(e, type, comment) =>
          //   handleEditComment({ ...comment, comment_title: editCommentTitle })
          // }
          newComment={newComment}
          setNewComment={setNewComment}
          onDelComment={onDelComment}
          editCommentTitle={editCommentTitle}
          setEditCommentTitle={setEditCommentTitle}
          onEditComment={onEditComment}
          editingCommentId={editingCommentId}
          setEditingCommentId={setEditingCommentId}
          onChangeDate={handleChangeDate}
          onDelTask={openDelTask}
          taskDetailLoading={taskDetailLoading}
          setTaskDetailLoading={setTaskDetailLoading}
          handleNavigate={handleNavigate}
        />
      )}

      <MuiDialog
        open={delTaskOpen}
        onToggle={closeDelTask}
        onAgree={handleDeleteTask}
        loading={processing}
        title="Delete Task"
        message="Are you sure you want to delete this task?"
      />
      <MuiDialog
        open={delCommentOpen}
        onToggle={closeDelCommentDialog}
        onAgree={handleDelTaskComment}
        loading={deletingTaskComment}
        title="Delete Comment"
        message={`Are you sure you want to delete this comment?`}
      />
    </div>
  );
}

export default OpenTaskDetail;
